export var SortFields;
(function (SortFields) {
    SortFields["ID"] = "id";
    SortFields["CLIENT_NAME"] = "clientName";
    SortFields["PET_NAME"] = "petName";
    SortFields["PET_BREED"] = "petBreed";
    SortFields["PET_TYPE"] = "petType";
    SortFields["SERVICE"] = "service";
    SortFields["STAFF"] = "staff";
    SortFields["DATE_TIME"] = "dateTime";
    SortFields["TOTAL"] = "total";
    SortFields["STATUS"] = "status";
})(SortFields || (SortFields = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASCENDANT"] = "ascendant";
    SortOrder["DESCENDANT"] = "descendant";
    SortOrder["DEFAULT"] = "default";
})(SortOrder || (SortOrder = {}));
